module.exports = __webpack_public_path__ + "static/media/drupal.630f9a83.svg";